import React from 'react'
import { node } from 'prop-types'
import styled from 'styled-components'
import { stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { greyDark, offWhite, black, borderColor } from 'styles/colors'
import { media } from 'styles/media'
import { lineHeights, fontWeights, fontSizes } from 'styles/typography'

const Container = styled.div`
  position: static;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${greyDark};
  }

  h1,
  h2 {
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.tight};
  }

  h3,
  h4,
  h5,
  h6 {
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.heading};
  }

  ul,
  ol {
    padding-left: ${spacing.large};
    margin-bottom: 1.25em;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: ${black};
      font-weight: ${fontWeights.medium};
      text-decoration: underline;
    }

    ${media.medium`
      margin-bottom: 1.5em;
    `};

    ul,
    ol {
      margin-top: 1em;
    }

    li + li {
      margin-top: ${spacing.small};
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid ${borderColor};
    margin-bottom: 1.25em;

    ${media.medium`
      margin-bottom: 1.5em;
    `};
  }

  td,
  th {
    padding: ${stripUnit(spacing.small) * 1.5 + 'px'} ${spacing.medium};
    border: 1px solid ${borderColor};
    text-align: left;
  }

  th {
    color: ${greyDark};
    font-size: ${fontSizes.small};
    background-color: ${offWhite};
  }

  small {
    font-size: ${fontSizes.tiny};
  }
`

const RichText = ({ children }) => <Container>{children}</Container>

RichText.propTypes = {
  children: node.isRequired
}

export default RichText
